(function(angular) {
    'use strict';

    angular.module('um.commonFilters').filter('paging', pagingFilter);
    function pagingFilter() {
        return function(input, startPage, itemsPerPage) {
            if (!input || !input.length) {
                return;
            }

            _.each(input, user => {user.isVisible = false});

            input = input.slice((startPage - 1) * itemsPerPage, startPage * itemsPerPage);

            _.each(input, user => {user.isVisible = true});

            return input;
        };
    }
})(window.angular);
